import { Component, OnInit } from '@angular/core';
//import { CommonModule } from '@angular/common';
import { HomeService } from './home.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [],
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit  {
  public error: boolean = false;
  public errorMessage: string = '';
  public showSpinner: boolean = false;

  constructor(private service: HomeService) {}

  ngOnInit(): void {
    //this.showSpinner = false; 
  }
}